<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-boxes" class="q-mb-sm" /> {{ $t('categories_modules') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-12">
                <q-field :count="256">
                    <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                </q-field>
            </div>

            <div class="col-xs-12 col-sm-12 q-mt-sm">
                <q-checkbox v-model="all_areas" :val="true" :label="$t('select_all_areas')" @input="checkAllAreas()" />
                <q-select v-model="area" :options="areas" :float-label="$t('areas')" :error="$v.area.$error" @input="$v.area.$touch" multiple chips clearable @clear="deselectAreas"/>
            </div>

            <div class="col-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="status_list" />
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="$router.push({ name: 'product_categories' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'presential', 'admin'] },

    data() {
        return {
            id: '',
            title: '',
            all_areas: false,
            status: 1,
            status_list: [
                { label: this.$t('active'), value: 1 },
                { label: this.$t('inactive'), value: 2 }
            ],
            area: [],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/manager_products/categories/${this.id}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.status = response.data.status
                this.area = response.data.areas
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('title', this.title)
                fd.append('status', this.status)

                this.area.forEach(area => {
                    fd.append('areas', area)
                })

                if (this.id != 0) {
                    this.$axios.put(`/manager_products/categories/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('product_category_save_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$router.push({ name: 'product_categories' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('product_category_save_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
                else {
                    this.$axios.post(`/manager_products/categories/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('product_category_save_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$router.push({ name: 'product_categories' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('product_category_save_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        checkAllAreas() {
            if(this.all_areas) {
                this.area = this.areas.map(e => e.value)
            }
            else {
                this.area = []
            }
        },

        deselectAreas() {
            this.all_areas = false
            this.area = []
        }
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256) },
            area: { required }
        }
    },

    created() {
        this.id = this.$route.params.id
        if (this.id != 0) this.fetchData()
    }
}
</script>

<style>

</style>
